__turbopack_context__.v({
  "banner": "security-module__41IsDa__banner",
  "maskRoot": "security-module__41IsDa__maskRoot",
  "maskValue": "security-module__41IsDa__maskValue",
  "maskValueHidden": "security-module__41IsDa__maskValueHidden",
  "revealBtn": "security-module__41IsDa__revealBtn",
  "sessionActions": "security-module__41IsDa__sessionActions",
  "sessionBtn": "security-module__41IsDa__sessionBtn",
  "sessionCountdown": "security-module__41IsDa__sessionCountdown",
});
